export const columns = [
	{ field: "customer", headerName: "Customer", flex: 1.5, minWidth: 100 },
	{ field: "username", headerName: "Username", flex: 1.5, minWidth: 100 },
	{ field: "agent", headerName: "Agent", flex: 1.5, minWidth: 100 },
];
